import { CheckCircle2, MessageCircle } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { CONTACT } from "@/lib/data";
import { brl } from "@/lib/pricing";

export default function SuccessDialog({ result, onClose }) {
  const wa = result ? `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(result.mensagem || "")}` : "#";
  return (
    <Dialog open={!!result} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="reservation-success-dialog" data-lenis-prevent className="max-w-md rounded-sm border-none bg-[#faf7f2] p-8 text-center">
        <CheckCircle2 className="mx-auto h-14 w-14 text-[#163323]" />
        <DialogTitle data-testid="success-title" className="mt-4 text-2xl font-bold leading-tight tracking-tight text-[#163323]">
          Sua reserva foi concluída com Sucesso!
        </DialogTitle>
        <DialogDescription className="mt-2 text-sm leading-relaxed text-[#3d4f44]">
          Recebemos sua solicitação de {result?.nights} diária{result?.nights === 1 ? "" : "s"} no valor total de{" "}
          <strong className="text-[#163323]">{brl(result?.total)}</strong>. Em breve entraremos em contato pelo WhatsApp para confirmar.
        </DialogDescription>
        <a
          href={wa}
          target="_blank"
          rel="noreferrer"
          data-testid="whatsapp-send-button"
          className="mt-6 flex items-center justify-center gap-2 rounded-full bg-[#163323] px-6 py-4 text-xs font-bold uppercase tracking-[0.18em] text-[#faf7f2] transition-colors duration-300 hover:bg-[#a4532f]"
        >
          <MessageCircle className="h-4 w-4" /> Falar conosco no WhatsApp
        </a>
        <button data-testid="success-close-button" onClick={onClose} className="mt-3 text-xs font-bold uppercase tracking-[0.2em] text-[#5a6e61] hover:text-[#163323]">
          Fechar
        </button>
      </DialogContent>
    </Dialog>
  );
}
